<template>
	<div class="v-comment">
		<div class="heading">
			<h3>评论 ({{total}})</h3>
		</div>
		<div class="v-comment-post">
			<Post :ref-type="refType" :ref-id="refId" />
		</div>
		<div class="v-comment-list" v-loading="loading">
			<Item
				v-for="item in list"
				:ref-type="refType"
				:ref-id="refId"
				:item="item"
				:user="user"
				:key="item.id"
			/>

			<div v-if="!list.length" class="notfound text-center">
				此内容暂无评论
			</div>

			<div v-if="total > 0">
				<el-pagination
					background
					layout="prev, pager, next"
					@current-change="getList"
					:current-page.sync="curPage"
					:page-size="parseInt(pageSize)"
					:total="total" 
					/>
			</div>
		</div>
	</div>
</template>

<script>
import Post from "@/components/Comment/Post";
import Item from "@/components/Comment/Item";

export default {
	name: "Comment",
	props: ["refId", "refType", "pageSize", "page"],
	components: { Post, Item },
	data() {
		return {
			user: undefined,
			total: 0,
			curPage: 1,
			list: [],
			loading: true
		};
	},
	methods: {
		getList(page, callback) {
			this.curPage = page
			this.loading = true
			this.axios
				.get(this.axios.apiGateway + "comment/list", {
					params: {
						refType: this.refType,
						refId: this.refId,
						pagesize: this.pageSize,
						page: page
					}
				})
				.then(res => {
					this.total = parseInt(res.data.total)
					this.list = res.data.list
					this.loading = false
					if (callback) {
						callback(res)
					}
				});
		}
	},
	created() {
		this.getList();

		this.$store.dispatch("notify", user => {
			this.user = user;
		});

		this.util.$on("reloadCommentList", (page, callback) => {
			this.getList(page ? page : this.curPage, callback);
		});
	}
};
</script>

<style lang="less">
.v-comment-post {
	position: relative;
	background: rgba(0,0,0,.05);
	padding: 20px;
	border-radius: 5px;
	margin-bottom: 30px;
	.form-reply-root {
		padding-left: 75px;
	}
	
	.at-user {
		margin-bottom: 6px;
	}
	.form-group {
		position: relative;
		margin-bottom: 10px;
		&.form-action {
			margin-bottom: 0;
			text-align: right;
		}
		.input-length {
			float: left;
			color: #888;
		}
		.nologin {
			position: absolute;
			left: 1px;
			right: 1px;
			top: 1px;
			bottom: 1px;
			padding: 10px;
			font-size: 14px;
			background: #fff;
			border-radius: 5px;
		}
	}
	.form-control {
		padding: 10px;
		font-size: 16px;
		max-height: 6em;
	}
	.avatar {
		position: absolute;
		left: 20px;
		width: 50px;
		height: 50px;
		overflow: hidden;
		border-radius: 100%;
		img {
			display: block;
			width: 100%;
			height: 100%;
		}
	}
}
.v-comment-list {
	border-radius: 5px;
	overflow: hidden;
	background: rgba(0,0,0,.02);
	
	.el-pagination {
		padding: 30px 0;
		text-align: center;
	}
	.notfound {
		font-size: 1.2rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue